import React from 'react';
import { connectMenu } from 'react-instantsearch-dom';

import Chevron from '../../assets/svg/chevron.svg';

const LibrarySearchTagFilter = connectMenu(
  ({ currentRefinement, items, refine }) => {
    return (
      <div className="w-full">
        <form action="" className="relative" noValidate>
          <select
            aria-label="Filter by Tag"
            className="w-full pb-3 bg-transparent border-b outline-none select-reset stink-body-3 border-smoke text-smoke"
            onChange={(event) => refine(event.currentTarget.value)}
            value={currentRefinement || ''}
          >
            <option value="">Filter by Tag</option>
            {items.map((item) => (
              <option
                key={item.label}
                value={item.isRefined ? currentRefinement : item.value}
              >
                {item.label}
              </option>
            ))}
          </select>
          <div className="absolute bottom-0 right-0 pb-3 pointer-events-none">
            <Chevron className="transform rotate-90 stroke-current w-2.5 text-creme" />
          </div>
        </form>
      </div>
    );
  },
);

export default LibrarySearchTagFilter;
